import { OpenModal } from '../../../../react-commons/utils/modals/openModal';
import { setToDirty } from '../ui-state/local-status/localStatusActions';
import { store } from '../../store';

export const showUnsavedDataAlert = (action: () => void) => {
    OpenModal.UnsavedChangesModal(() => {
        action();
        store.dispatch(setToDirty(false));
    });
};